import hr from './hr';
import enSierraLeone from './en-sierra-leone';

const exportObject = {
   ...hr,
   ...enSierraLeone
};

export default exportObject;
